module.exports = __webpack_public_path__ + "img/2024-09_academic-excellence.eb88c5e4.jpg";